import { render, staticRenderFns } from "./RiskAlert.vue?vue&type=template&id=5411359e&scoped=true&"
import script from "./RiskAlert.vue?vue&type=script&lang=js&"
export * from "./RiskAlert.vue?vue&type=script&lang=js&"
import style0 from "./RiskAlert.vue?vue&type=style&index=0&id=5411359e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5411359e",
  null
  
)

export default component.exports